module.exports = __webpack_public_path__ + "static/roseknitbear-8be912a74a717c9b20ab7ccf9a63923a.jpeg";